import axios from "axios";
import React, { useState,useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const Policies = () => {
  const [PoliciesData, setPoliciesData] = useState([]);
  const {t} = useTranslation();

  useEffect(() => {
    const fetchData = async () => {
      const response = await axios.get(
        "https://cyberathon.com/silverapartment/index.php/Api/Silver_Controller/policy_list"
      );
      setPoliciesData(response.data.data);
    };

    fetchData();
  }, []);

  return (
    <div className="container-fluid policies-div">
      <div className="breadcrumb-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div
                className="breadcrumb-text"
                data-aos="fade-down"
                data-aos-duration={3000}
              >
                <h1 style={{fontSize:"44px"}}>Our Policies</h1>
                <div className="bt-option">
                  <Link to="/">Home</Link>
                  <span>Policies</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
        <div className="container">
      <div className="row policy-detail">
          <div>
            {PoliciesData.map((Data) => (
            <ul>
            <li>
             {Data.policy_details}
            </li>
            </ul>
        ))}
        </div>
        </div>
      </div>
    </div>
  );
};

export default Policies;
